import * as yup from 'yup';
import { useI18n } from 'vue-i18n';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';
import { buildLanguageFields } from '@/core/helpers/yup-validation.helper';

export function getRules() {
   const { t } = useI18n();
   const jobBoardStore = useJobBoardStore();

   const languages = jobBoardStore.currentJobBoard?.languages ?? [];
   const titleLanguageFields = buildLanguageFields(languages, { max: 255 });
   const descriptionLanguageFields = buildLanguageFields(languages);

   return yup.object({
      rows: yup.array().of(
         yup.object({
            image_id: yup.number().required(t('live-editor.content-blocks.errors.required')),
            title: yup.object(titleLanguageFields).nullable(),
         }),
      ),
   });
}
